<template>
  <div class="d-flex">
    <div class="mx-2 flex-grow-1" v-if="filterByClient">
      <label for="client_input">Filter by client</label>
      <div class="client-box">
        <div class="input-holder">
          <v-select id="client_input"
                    ref="client_input"
                    v-model="selected_client_id"
                    label="name"
                    :reduce="e => e.id"
                    :value="selected_client_id"
                    :options="allClients"
                    class="triangle-selector"
          >
            <template slot="search" slot-scope="scope">
              <input class="vs__search"
                     v-bind="scope.attributes"
                     v-on="scope.events"
                     @keydown="selectValueInput($event,scope,'clients','client_input')"
              >
            </template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="mx-2 flex-grow-1">
      <label for="website_input">Filter by Website</label>
      <div class="client-box">
        <div class="input-holder">
          <v-select id="website_input"
                    ref="website_input"
                    v-model="selected_website"
                    label="name"
                    :options="allSites"
                    :components="{Deselect}"
                    class="triangle-selector"
          >
          </v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterByClientWebsite",
  props: {
    items: {
      type: Array,
      required: true
    },
    filterByClient: {
      type: Boolean
    }
  },
  data: () => ({
    selected_client_id: null,
    selected_website: '',
    Deselect: {
      render: createElement => {
        const el = createElement('i', {
          attrs: {
            class: 'icon-close'
          }
        });
        return el;
      },
    },
  }),
  methods: {
    selectValueInput(key, scope, refName, refInput) {
      if (key.keyCode === 13) {
        let slOb = this.$refs[refInput];
        return slOb && slOb.typeAheadSelect();
      }
    },
  },
  watch: {
    selected_client_id() {
      this.selected_website = null
      this.$emit('filterChange',this.selected_client_id,this.selected_website)
    },
    selected_website() {
      this.$emit('filterChange',this.selected_client_id,this.selected_website)
    }
  },
  computed: {
    filteredSites() {
      let allItems = (this.allSites && this.allSites.length) ? this.allSites : [];
      if (this.selected_client_id) {
        allItems = allItems.filter(i => i.client_id === this.selected_client_id)
      }
      return allItems;
    },
    allSites() {
      let allItems = this.items || [];
      if (!allItems.length) return [];

      allItems = allItems.reduce((acc, e) => {
        if (!acc.find(ae => ae.id === e.website_id)) acc.push({
          id: e.website_id,
          name: e.website,
          client_id: e.client_id
        });
        return acc;
      }, []);

      allItems = allItems.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });

      return allItems;
    },
    allClients() {
      let allItems = this.$store.state.refs.clients_active || [];
      return allItems.length ? allItems : [];
    },
  }
}
</script>

<style scoped>

</style>